<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert type="info" show-icon style="margin-bottom:16px" message="打开「展示」后会出现在客户端共享设计室入口页下方；国内版 / 国际版分开配置。排序数字越小越靠前。" />
      <a-tabs v-model="region" @change="onRegionChange">
        <a-tab-pane key="cn" tab="国内版" />
        <a-tab-pane key="en" tab="国际版" />
      </a-tabs>
      <div class="bar">
        <a-input v-model="query.keyword" placeholder="商品/用户/订单号/内容" style="width:280px" allow-clear />
        <a-select v-model="query.shown" allow-clear placeholder="展示状态" style="width:140px">
          <a-select-option :value="1">已展示</a-select-option>
          <a-select-option :value="0">未展示</a-select-option>
        </a-select>
        <a-button type="primary" @click="search">查询</a-button>
      </div>
      <a-table row-key="aid" :data-source="rows" :columns="columns" :pagination="pagination" :loading="loading" @change="page" style="margin-top:16px">
        <template slot="user" slot-scope="t, r">
          <div>{{ r.nickname || '-' }}</div>
          <small>ID {{ r.user_id }} · {{ r.country || '' }}</small>
        </template>
        <template slot="star" slot-scope="t, r"><a-rate :value="Number(r.star)" disabled /></template>
        <template slot="content" slot-scope="t, r">
          <div>{{ r.content }}</div>
          <div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:6px">
            <img v-for="(url, i) in commentImages(r.thumb)" :key="i" :src="url" v-image-preview style="width:56px;height:56px;object-fit:cover" />
          </div>
        </template>
        <template slot="show" slot-scope="t, r">
          <a-switch :checked="Number(currentShow(r)) === 1" checked-children="展示" un-checked-children="隐藏" v-hasPermi="['dkmall:comment:design-display:edit']" @change="v => toggleShow(r, v)" />
        </template>
        <template slot="sort" slot-scope="t, r">
          <a-input-number :value="Number(r.sort)" :min="0" :max="99999" size="small" v-hasPermi="['dkmall:comment:design-display:edit']" @change="v => changeSort(r, v)" />
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listDesignComments, setDesignCommentShow, setDesignCommentSort } from '@/api/dkmall/catalog-maintenance'

export default {
  name: 'DkDesignCommentDisplay',
  data() {
    return {
      region: 'cn',
      loading: false,
      query: { keyword: '', shown: undefined, pageNum: 1, pageSize: 20 },
      rows: [],
      total: 0,
      columns: [
        { title: '订单号', dataIndex: 'order_sn', width: 160 },
        { title: '商品', dataIndex: 'goods_name', width: 160, customRender: v => v || '共享设计室' },
        { title: '用户', scopedSlots: { customRender: 'user' }, width: 140 },
        { title: '评分', scopedSlots: { customRender: 'star' }, width: 140 },
        { title: '评价内容', scopedSlots: { customRender: 'content' } },
        { title: '时间', dataIndex: 'create_time', customRender: v => this.time(v), width: 160 },
        { title: '展示', scopedSlots: { customRender: 'show' }, width: 110 },
        { title: '排序', scopedSlots: { customRender: 'sort' }, width: 110 }
      ]
    }
  },
  computed: {
    pagination() {
      return { current: this.query.pageNum, pageSize: this.query.pageSize, total: this.total, showSizeChanger: true }
    }
  },
  created() { this.load() },
  methods: {
    currentShow(r) { return this.region === 'en' ? r.design_show_en : r.design_show_cn },
    commentImages(value) {
      if (Array.isArray(value)) return value
      try { const rows = JSON.parse(value); if (Array.isArray(rows)) return rows.map(r => typeof r === 'string' ? r : r.url || r.path).filter(Boolean) } catch (e) {}
      return String(value || '').split(',').filter(Boolean)
    },
    time(v) { return v ? new Date(Number(v) * 1000).toLocaleString() : '-' },
    onRegionChange() { this.query.pageNum = 1; this.load() },
    search() { this.query.pageNum = 1; this.load() },
    load() {
      this.loading = true
      listDesignComments({ region: this.region, keyword: this.query.keyword, shown: this.query.shown, pageNum: this.query.pageNum, pageSize: this.query.pageSize })
        .then(r => { this.rows = (r.data && r.data.rows) || []; this.total = Number((r.data && r.data.total) || 0) })
        .finally(() => { this.loading = false })
    },
    page(p) { this.query.pageNum = p.current; this.query.pageSize = p.pageSize; this.load() },
    toggleShow(r, checked) {
      const show = checked ? 1 : 0
      setDesignCommentShow(r.aid, this.region, show).then(() => {
        if (this.region === 'en') r.design_show_en = show; else r.design_show_cn = show
        this.$message.success(show ? '已开启展示' : '已关闭展示')
      })
    },
    changeSort(r, value) {
      if (value === null || value === undefined) return
      const sort = Number(value)
      setDesignCommentSort(r.aid, sort).then(() => { r.sort = sort; this.$message.success('排序已更新') })
    }
  }
}
</script>

<style scoped>
.bar { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; }
</style>
